import {useEffect, useState} from 'react';
import globalDomains from '@/utils/global-domains';
import {formatCurrentTime} from '@/utils/help/chatbot';
import {ROUTE} from '@/constants/main/route';
import {SOOP, USER} from '@/constants/help';
import {
  BotMessageType,
  MessageType,
} from '@/components/help/common/Chatbot/type';
import {useSendMessage} from './useSendMessage';
import {useGetRecommendKeyword} from './useGetRecommendKeyword';

export const useChatbotMessages = () => {
  // 대화 배열
  const [messages, setMessages] = useState<MessageType[]>([]);

  // 추천 키워드 조회 완료 후 첫 메시지 추가
  const {
    data: recommendKeyword,
    isSuccess,
    isFetched,
  } = useGetRecommendKeyword();
  useEffect(() => {
    if (!isFetched) {
      return;
    }

    const message: BotMessageType = {
      role: SOOP,
      text: '안녕하세요, SOOP 챗봇 숲덕이에요.\n궁금한 내용을 알려주세요.',
      keywords: [],
      links: [],
      date: formatCurrentTime(),
    };
    if (isSuccess) {
      message.keywords = recommendKeyword.slice(0, 6);
    }
    setMessages((prev) => [...prev, message]);
  }, [isSuccess, recommendKeyword, setMessages, isFetched]);

  const [errorCount, setErrorCount] = useState(0);
  const createErrorMessage = (): BotMessageType => {
    // 응답 1회 실패 시 재시도 유도
    // 응답 2회 실패 시 문의하기 노출
    let message: BotMessageType = {
      role: SOOP,
      text: '',
      keywords: [],
      links: [],
      date: formatCurrentTime(),
    };

    const count = errorCount + 1;
    if (count > 1) {
      message.text =
        '입력하신 내용을 찾을 수 없어요.\n\n궁금하신 내용을 다시 입력해 주시거나\n1:1 문의를 통해 도와드릴게요.';
      message.links.push({
        title: '1:1 문의',
        url: `${globalDomains.WWW_AFREECATV}${ROUTE.HELP.INQUIRY}`,
      });

      setErrorCount(0);
    } else {
      message.text =
        '문의하신 내용을 찾지 못했어요.\n궁금하신 사항을 다시 입력해 주세요.';
      setErrorCount(count);
    }
    return message;
  };

  const {mutate: sendMessage, isPending} = useSendMessage({
    onSuccess: (message) => {
      setMessages((prev) => [...prev, message]);
      setErrorCount(0);
    },
    onError: () => {
      setMessages((prev) => [...prev, createErrorMessage()]);
    },
  });

  const handleSend = (text: string, callback?: () => void) => {
    if (isPending) {
      return;
    }

    setMessages((prev) => [
      ...prev,
      {
        role: USER,
        text,
        date: formatCurrentTime(),
      },
    ]);
    sendMessage(text);
    callback?.();
  };

  return {messages, handleSend, isPending};
};
